/*
 * Free shipping bar — confetti burst when the customer crosses the threshold.
 *
 * The cart drawer / cart page re-render their contents on every cart change,
 * replacing the .free-shipping-bar element. We watch those containers with a
 * MutationObserver and fire confetti only on the transition from "not complete"
 * to "complete" (so it doesn't replay on every render or just on opening).
 *
 * Self-contained: no external library. Honors prefers-reduced-motion.
 */
(function () {
  if (window.__fsbConfettiInit) return;
  window.__fsbConfettiInit = true;

  var celebrating = false;
  var wasComplete = false;

  function completeBar() {
    return document.querySelector('.free-shipping-bar--complete');
  }

  function maybeCelebrate() {
    var bar = completeBar();
    var nowComplete = !!bar;
    if (nowComplete && !wasComplete && bar.getAttribute('data-fsb-confetti') === 'true') {
      // Small delay so the drawer finishes sliding in before we measure its width.
      window.setTimeout(confetti, 400);
    }
    wasComplete = nowComplete;
  }

  function observe(el) {
    if (!el) return;
    new MutationObserver(function () {
      window.requestAnimationFrame(maybeCelebrate);
    }).observe(el, { childList: true, subtree: true });
  }

  function init() {
    // Don't fire on first load if the cart is already over the threshold.
    wasComplete = !!completeBar();
    observe(document.getElementById('CartDrawer'));
    observe(document.getElementById('main-cart-items'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function confetti() {
    if (celebrating) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    celebrating = true;

    // Cover only the cart drawer panel (or cart container), not the whole screen.
    var bar = document.querySelector('.free-shipping-bar--complete') || document.querySelector('.free-shipping-bar');
    var area = bar && bar.closest('.drawer__inner, #main-cart-items, cart-drawer');
    var rect = area
      ? area.getBoundingClientRect()
      : { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };

    var canvas = document.createElement('canvas');
    canvas.style.cssText =
      'position:fixed;left:' + rect.left + 'px;top:' + rect.top + 'px;width:' + rect.width +
      'px;height:' + rect.height + 'px;pointer-events:none;z-index:2147483647;';
    canvas.width = Math.max(1, Math.round(rect.width));
    canvas.height = Math.max(1, Math.round(rect.height));
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var colors = ['#e0a200', '#1a8a4a', '#ff6b6b', '#4dabf7', '#f06595', '#ffd43b'];
    var pieces = [];
    for (var i = 0; i < 55; i++) {
      pieces.push({
        x: Math.random() * canvas.width,
        y: -20 - Math.random() * canvas.height * 0.4,
        w: 4 + Math.random() * 4,
        h: 5 + Math.random() * 5,
        color: colors[i % colors.length],
        vx: -2.5 + Math.random() * 5,
        vy: 2 + Math.random() * 3.5,
        rot: Math.random() * Math.PI * 2,
        vrot: -0.25 + Math.random() * 0.5
      });
    }

    var DURATION = 2400;
    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // Discreet: low base opacity that softly fades out as the pieces fall.
      var fade = elapsed < DURATION * 0.45
        ? 1
        : Math.max(0, 1 - (elapsed - DURATION * 0.45) / (DURATION * 0.55));
      ctx.globalAlpha = 0.55 * fade;
      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.06;
        p.rot += p.vrot;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      if (elapsed < DURATION) {
        window.requestAnimationFrame(frame);
      } else {
        canvas.remove();
        celebrating = false;
      }
    }
    window.requestAnimationFrame(frame);
  }
})();
